import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/calendarButton/calendar-add.svg'


const _hoisted_1 = { class: "flex items-center mr-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-2 icon",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "xxsm:text-xs cursor-pointer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openGoogleCalendar && _ctx.openGoogleCalendar(...args))),
      class: "text-blue-500"
    }, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("add_to_calendar")), 1)
    ])
  ]))
}